// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_core_shell_header_profile-mannagement_profile-mannagement_module_ts":"789cbfd9e26d397d","src_app_offline-quote_offline-quote_module_ts":"a4bea4fdcb1ee866"}[chunkId] + ".js";
};